import styled from "styled-components";

export const OrangeSpan = styled.span`
   color: #e54f17;
   `;

